(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4489],{

/***/ 2938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/prototype",
      function () {
        return __webpack_require__(5754);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _accordion_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74905);

//기존 accordion를 사용하려다가 props 에러 발생해서 index 추가 후 사용함.



var Accordion2 = function(props) {
    var data = props.data, open = props.open, index = props.index; // index prop 추가
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), activeTab = ref[0], setActiveTab = ref[1];
    var handleActive = function(index) {
        // index 매개변수 추가
        setActiveTab(function(prev) {
            return !prev;
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open !== undefined) {
            setActiveTab(open);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionBox */ .Rk, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionHeader */ ._m, {
                    onClick: function() {
                        return handleActive(index);
                    },
                    active: activeTab,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionTitle */ .il, {
                            children: data === null || data === void 0 ? void 0 : data.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: activeTab ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fi-rs-angle-up"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fi-rs-angle-down"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionBody */ .X1, {
                    active: activeTab,
                    children: data === null || data === void 0 ? void 0 : data.content
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion2);


/***/ }),

/***/ 5754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customizing_prototype; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./api/apis.js
var apis = __webpack_require__(66887);
// EXTERNAL MODULE: ./api/checkSiteConfig.js
var checkSiteConfig = __webpack_require__(81197);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./components/group-event/GroupEvent.styles.js
var GroupEvent_styles = __webpack_require__(11282);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/CustomFileInput.js
var CustomFileInput = __webpack_require__(62645);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./common/input/floatingInput.js
var floatingInput = __webpack_require__(44025);
// EXTERNAL MODULE: ./components/group-event/types/typeOne.styles.js
var typeOne_styles = __webpack_require__(88911);
// EXTERNAL MODULE: ./common/accordion/accordion2.js
var accordion2 = __webpack_require__(517);
;// CONCATENATED MODULE: ./components/group-event/types/typeThird.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TypeThird = function(param) {
    var userInfoList = param.userInfoList, inputData = param.inputData, setInputData = param.setInputData, handleInputData = param.handleInputData;
    var ref12;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, errors = ref1.formState.errors, setValue = ref1.setValue, getValues = ref1.getValues, reset = ref1.reset, trigger = ref1.trigger;
    var ref2 = (0,react.useState)([]), activeTab = ref2[0], setActiveTab = ref2[1];
    var fileRef = (0,react.useRef)();
    var accordionData = [
        {
            title: "\uBB38\uC758 \uB0B4\uC6A9",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-group mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", _objectSpread({
                            placeholder: "\uBB38\uC758\uB0B4\uC6A9",
                            className: "mt-3",
                            name: "memo",
                            value: (inputData === null || inputData === void 0 ? void 0 : inputData.memo) || ""
                        }, register("memo", {
                            value: inputData === null || inputData === void 0 ? void 0 : inputData.memo,
                            onChange: function(e) {
                                return handleInputData(e, "memo");
                            }
                        }))),
                        (errors === null || errors === void 0 ? void 0 : errors.memo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mt-1 text-danger",
                            children: errors === null || errors === void 0 ? void 0 : errors.memo.message
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex align-items-center justify-content-between mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "",
                                        children: "\uD30C\uC77C \uC5C5\uB85C\uB4DC"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: fileRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFileInput/* default */.Z, {
                                        handleFiles: function(files) {
                                            setInputData(_objectSpread({}, inputData, {
                                                file: files[0]
                                            }));
                                        },
                                        reset: function(files) {
                                            return reset(_objectSpread({}, getValues(), {
                                                file: files[0]
                                            }));
                                        },
                                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.file) || "",
                                        error: errors === null || errors === void 0 ? void 0 : errors.file,
                                        name: "file",
                                        max: 1
                                    })
                                }),
                                (errors === null || errors === void 0 ? void 0 : errors.file) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mt-1 text-danger",
                                    children: errors === null || errors === void 0 ? void 0 : errors.file.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "* \uC774\uBBF8\uC9C0\uAC00 2\uAC1C \uC774\uC0C1\uC774\uB77C\uBA74 zip\uC73C\uB85C \uC555\uCD95\uD574\uC11C \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 d-flex flex-column",
                            children: (errors === null || errors === void 0 ? void 0 : errors.editYn) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mt-1 text-danger",
                                children: errors === null || errors === void 0 ? void 0 : errors.editYn.message
                            })
                        })
                    ]
                })
            })
        },
        {
            title: "\uC8FC\uBB38\uC790 \uC815\uBCF4",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC5C5\uCCB4\uBA85",
                        name: "company",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.company) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uB2F4\uB2F9\uC790",
                        name: "name",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.name) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC5F0\uB77D\uCC98",
                        name: "phone",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.phone) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.phone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC774\uBA54\uC77C",
                        name: "email",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.email) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-fles flex-column mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custome-checkbox d-flex align-items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                        type: "checkbox",
                                        id: "checkBox0",
                                        className: "form-check-input",
                                        style: {
                                            paddingTop: "2px"
                                        },
                                        checked: (inputData === null || inputData === void 0 ? void 0 : inputData.check) || ""
                                    }, register("check", {
                                        onChange: function(e) {
                                            return handleInputData(e, "check");
                                        }
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "checkBox0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "checkBox0",
                                        children: "(\uB3D9\uC758 \uD544\uC218) \uC81C\uCD9C\uD558\uC2E0 \uC815\uBCF4\uB85C \uC2E0\uCCAD\uC790\uAED8 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uC18C\uC2DD\uC744 \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4."
                                    })
                                ]
                            }),
                            (errors === null || errors === void 0 ? void 0 : errors.check) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref12 = errors.check) === null || ref12 === void 0 ? void 0 : ref12.message
                            })
                        ]
                    })
                ]
            })
        }, 
    ];
    // inputData가 변경될 때마다 form 값 동기화
    (0,react.useEffect)(function() {
        if (userInfoList) {
            var ref, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            var updatedData = {
                base_addr: ((ref = userInfoList.Address) === null || ref === void 0 ? void 0 : (ref3 = ref.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.base_addr) || "",
                detail_addr: ((ref5 = userInfoList.Address) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.detail_addr) || "",
                company: ((ref8 = userInfoList.Company) === null || ref8 === void 0 ? void 0 : ref8.ReturnCode) === "9999" ? "" : inputData.company,
                email: ((ref9 = userInfoList.Member) === null || ref9 === void 0 ? void 0 : ref9.email) || "",
                name: ((ref10 = userInfoList.Member) === null || ref10 === void 0 ? void 0 : ref10.name) || "",
                phone: ((ref11 = userInfoList.Member) === null || ref11 === void 0 ? void 0 : ref11.phone) || ""
            };
            setInputData(function(prev) {
                return _objectSpread({}, prev, updatedData);
            });
            // form 값 업데이트 및 에러 초기화
            reset(updatedData);
        }
    }, [
        userInfoList,
        reset
    ]);
    //에러 관련해서 scroll
    (0,react.useEffect)(function() {
        if (Object.keys(errors).length > 0) {
            var tempArr = new Array(accordionData.length).fill(true);
            setActiveTab(tempArr);
            if (Object.keys(errors).length === 1 && errors.file) {
                stickyBodyRef.current.scrollTo({
                    behavior: "instant",
                    left: 0,
                    top: fileRef.current.offsetTop - 130
                });
            }
        }
    }, [
        errors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typeOne_styles/* TypeOneSection */.h, {
            children: (accordionData === null || accordionData === void 0 ? void 0 : accordionData.length) > 0 && accordionData.map(function(el, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion2/* default */.Z, {
                    data: el,
                    open: activeTab[i]
                }, i);
            })
        })
    });
};
/* harmony default export */ var typeThird = (TypeThird);

// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./common/validation.js
var validation = __webpack_require__(10103);
// EXTERNAL MODULE: ./components/cart/cart-styles.js
var cart_styles = __webpack_require__(67503);
// EXTERNAL MODULE: ./api/getUserInfo.js + 1 modules
var getUserInfo = __webpack_require__(48934);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/customizing/prototype/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function prototype_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function prototype_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            prototype_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



















var PrototypePage = function() {
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), isActive = ref6[0], setIsActive = ref6[1]; //활성화
    var ref1 = (0,getUserInfo/* useGetUserInfo */.Jh)(), userInfoList = ref1.data, userInfoLoading = ref1.isLoading, refetch = ref1.refetch;
    // siteConfig 조회
    var ref2 = (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.SITE_CONFING.INDEX */.U.SITE_CONFING.INDEX,
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "Config",
                            division: "store",
                            channel: sessionStorage.getItem("channelName") === "\uBC14\uB85C\uACE0" ? "BAROGO" : ""
                        };
                        _ctx.next = 3;
                        return (0,checkSiteConfig/* default */.Z)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        if ((ref = res.Data.channel) === null || ref === void 0 ? void 0 : ref.token) {
                            sessionStorage.setItem("channel", res.Data.channel.token);
                            sessionStorage.setItem("channelName", res.Data.channel.company);
                        }
                        return _ctx.abrupt("return", res.Data);
                    case 8:
                        throw new Error("\uC0AC\uC774\uD2B8 \uC124\uC815 \uC870\uD68C \uC2E4\uD328");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    }), siteConfig = ref2.data;
    var prototypeCode = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Prototype;
    var ref3 = (0,useQuery/* useQuery */.a)({
        queryKey: prototypeCode ? queryKeys/* QUERY_KEYS.CUSTOMIZING.PROTOTYPE.DETAIL */.U.CUSTOMIZING.PROTOTYPE.DETAIL(prototypeCode) : [],
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, body, res, ref7, ref8, ref9, ref10;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (prototypeCode) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 3:
                        body = {
                            modes: "ViewSet",
                            code: siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Prototype
                        };
                        _ctx.next = 6;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 6:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 11;
                            break;
                        }
                        ;
                        setIsActive(((ref7 = res.Data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Row) === null || ref8 === void 0 ? void 0 : ref8.useYn) !== null);
                        return _ctx.abrupt("return", prototype_objectSpread({}, (ref9 = res.Data) === null || ref9 === void 0 ? void 0 : ref9.Row, {
                            info: res === null || res === void 0 ? void 0 : (ref10 = res.Data) === null || ref10 === void 0 ? void 0 : ref10.Info
                        }));
                    case 11:
                        throw new Error(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uC870\uD68C \uC2E4\uD328");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        enabled: !!(siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Prototype),
        staleTime: 0,
        refetchOnMount: false,
        onError: function(error) {
            (0,common_alert/* failAlert */.qh)(error.message);
        }
    }), detailData = ref3.data, detailDataLoaing = ref3.isLoading, refetchDetailData = ref3.refetch;
    (0,react.useEffect)(function() {
        if (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Prototype) {
            refetchDetailData();
        }
    }, [
        siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Prototype
    ]);
    // form
    var typeThirdOptions = {
        resolver: (0,yup/* yupResolver */.X)(validation/* GPTypeThirdSchema */.gW),
        mode: "onChange"
    };
    var methods = (0,index_esm/* useForm */.cI)(typeThirdOptions);
    var handleSubmit = methods.handleSubmit;
    var ref4 = (0,react.useState)({
        check: false
    }), inputData = ref4[0], setInputData = ref4[1];
    var ref5 = (0,react.useState)(false), isFormLoading = ref5[0], setIsFormLoading = ref5[1];
    var handleInputData = function(e, key) {
        if (key === "check") {
            setInputData(prototype_objectSpread({}, inputData, prototype_defineProperty({}, key, e.target.checked)));
            return;
        }
        setInputData(prototype_objectSpread({}, inputData, prototype_defineProperty({}, key, e.target.value)));
    };
    // 문의 등록
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var body, res, ref, ref11;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsFormLoading(true);
                        _ctx.prev = 1;
                        body = prototype_objectSpread({
                            modes: "InsertSet",
                            code: siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Promotion
                        }, data);
                        _ctx.next = 5;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 5:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            methods.reset(); //form 초기화
                            setInputData({
                                check: false
                            }); //inputdata 초기화
                            refetch(); //유저 정보 재조회
                            router.reload(); // 새로고침
                        } else if (res.Code === "8888") {} else {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref11 = res.Data) === null || ref11 === void 0 ? void 0 : ref11.Msg) || "\uB4F1\uB85D \uC2E4\uD328\uC785\uB2C8\uB2E4.");
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,common_alert/* failAlert */.qh)("\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.");
                    case 12:
                        _ctx.prev = 12;
                        setIsFormLoading(false);
                        return _ctx.finish(12);
                    case 15:
                        methods.reset();
                        setInputData({
                            check: false
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9,
                    12,
                    15
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uB9DE\uCDA4\uC81C\uC791",
            subTitle: "\uC2DC\uC81C\uD488\uC81C\uC791",
            pageTitle: SeoMeta/* SeoMeta.prototypeCreation.title */.e.prototypeCreation.title,
            pageDesc: SeoMeta/* SeoMeta.prototypeCreation.description */.e.prototypeCreation.description,
            pageKeyword: SeoMeta/* SeoMeta.prototypeCreation.keywords */.e.prototypeCreation.keywords,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* Container */.W2, {
                className: "container",
                children: !isActive ? // {/* 데이터 x */}
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* EmptyWrapper */.zD, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://image.caretbio.com/store/webhard/\u110C\u1175\u110F\u1161\u11AF\u1105\u1166\u11BA_\u1110\u1161\u11AB\u1109\u1169_420x200.png",
                            alt: "empty-edu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "title",
                            children: "\uD604\uC7AC \uBB38\uC758\uAC00\uB2A5\uD55C \uC2DC\uC81C\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/esg-guide/letter",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "btn",
                                    children: "ESG \uB274\uC2A4\uB808\uD130 \uBCF4\uB7EC\uAC00\uAE30"
                                })
                            })
                        })
                    ]
                }) : //  {/* 데이터 o */}
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* DetailWrapper */.c0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* DetailSection */.Kk, {
                            className: "single-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: detailData === null || detailData === void 0 ? void 0 : detailData.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: detailData === null || detailData === void 0 ? void 0 : detailData.content
                                    },
                                    className: "ck-content"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, prototype_objectSpread({}, methods, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* StickySection */.hI, {
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "mb-3",
                                        children: "\uC2DC\uC81C\uD488\uC81C\uC791 \uC2E0\uCCAD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* StickyBody */.ed, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typeThird, {
                                            userInfoList: userInfoList === null || userInfoList === void 0 ? void 0 : userInfoList.Data,
                                            inputData: inputData,
                                            setInputData: setInputData,
                                            handleInputData: handleInputData
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* StickyFooter */.oW, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            className: "btn confirm",
                                            children: isFormLoading ? "\uCC98\uB9AC\uC911..." : "\uBB38\uC758\uD558\uAE30"
                                        })
                                    })
                                ]
                            })
                        }))
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var customizing_prototype = (PrototypePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,7533,2511,4027,7503,5582,9774,2888,179], function() { return __webpack_exec__(2938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);